export default __webpack_public_path__ + "static/media/safari-activation-steps.f770b767.png";